enum ManagerGroupedInvestmentEndpoints {
  getOne = "/manager/grouped-investment",
  getMany = "/manager/grouped-investments",
}

export default ManagerGroupedInvestmentEndpoints;
